import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
	answer: {
		display: 'flex',
		alignItems: 'center',
	},
	center: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
}));

export default useStyles;
